/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {useCallback, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box";
import {Link} from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import {GridLogicOperator} from "@mui/x-data-grid-pro";

import {useApiCallback} from "../util/Api";
import {useLoginStore} from "../useLoginStore";
import {cellDefaults, DataGrid} from "../part/DataGrid";


const GroupInfoLink = ({group, navigate, children}) => (
    <Link color="inherit"
          sx={{lineHeight: '160%', textDecoration: 'none', '&:hover': {textDecoration: 'underline'}, cursor: 'pointer'}}
          onClick={() => navigate(`/group/${group.email}`)}
    >{children}</Link>
)

export default function Groups() {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const canUser = useLoginStore(state => state.canUser);
    const canUserSeeGroups = canUser('GET', '/api/groups')
    const [newGroup, setNewGroup] = useState('')

    const [groups, setGroups] = useState([]);
    const getGroups = useApiCallback('GET', '/api/groups?format=list', {setLoading, onDone: setGroups})
    useEffect(() => {
        setGroups([])
        if (canUserSeeGroups)
            return getGroups()
    }, [canUserSeeGroups, getGroups]);

    const navigateToGroup = useCallback(() => navigate(`/group/${newGroup}`), [navigate, newGroup])
    const createGroup = useApiCallback('POST', `/api/groups/${newGroup}`, {setLoading, data: {}, onDone: navigateToGroup})

    return <Container><Stack sx={{fontSize:{xs:'0.8em',sm:'0.9em',md:'1em'}}}>
        <Box container>
            <Stack direction="row" alignItems="center" spacing={2}>
                <TextField
                    label="New Group Name"
                    disabled={loading}
                    InputLabelProps={{shrink: true}}
                    value={newGroup}
                    inputProps={{autocomplete:"none"}}
                    onChange={(event) => {
                        setNewGroup(event.target.value)
                    }}
                    sx={{width: '300px', margin: 2}}/>
                <Button
                    onClick={() => createGroup()}
                >Create Internal Group</Button>
            </Stack>

            <DataGrid
                wrapperStyle={{height: 'calc(100dvh - 140px)'}}
                loading={loading}
                rows={groups}
                getRowId={row => row?.email}
                columns={[
                    {field: 'type', headerName: 'Group Type', flex: 4, ...cellDefaults,
                    },
                    {field: 'email', headerName: 'Email', flex: 4, ...cellDefaults,
                        headerAlign: 'right',
                        align: 'right',
                        renderCell: cell => <GroupInfoLink group={cell?.row} navigate={navigate}>{cell.value}</GroupInfoLink>,
                    },
                    {field: 'name', headerName: 'Name', flex: 4, ...cellDefaults,
                        headerAlign: 'left',
                        align: 'left',
                        renderCell: cell => <GroupInfoLink group={cell?.row} navigate={navigate}>{cell.value}</GroupInfoLink>,
                    },
                ]}
                initialState={{
                    sorting: {
                        sortModel: [
                            {field: 'name', sort: 'desc'},
                        ],
                    },
                    filter: {
                        filterModel: {
                            items: [
                                {field: 'type', operator: 'doesNotEqual', value: 'Google'},
                            ],
                            logicOperator: GridLogicOperator.And,
                        }
                    }
                }}
            />
        </Box>
    </Stack></Container>
}
